import { Message } from 'primeng/api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserLoginService } from '../user-login.service';
import { CognitoCallback } from '../cognito.service';

@Component({
    selector: 'app-forgot-password-2',
    templateUrl: './forgot-password-2.component.html'
})
export class ForgotPassword2Component implements CognitoCallback, OnInit, OnDestroy {

    verificationCode: string;
    email: string;
    password: string;
    errorMessages: Message[];
    private sub: any;

    constructor(public router: Router, public route: ActivatedRoute,
        public userService: UserLoginService) {
        console.log('email from the url: ' + this.email);
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe({
            next: params => {
                this.email = params['email'];
            }
        });
        this.errorMessages = [];
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    onNext() {
        this.errorMessages = [];
        this.userService.confirmNewPassword(this.email, this.verificationCode, this.password, this);
    }

    cognitoCallback(message: string) {
        if (message != null) { // error
            this.errorMessages = [({ severity: 'error', detail: message })];
            console.log('result: ' + message);
        } else { // success
            // this.router.navigate(['/login']);
            this.router.navigate(['/'], { queryParams: {} });
        }
    }
}
